import React from 'react';

import { Button } from 'modules/cxi/components/button';
import { useCXI } from 'modules/cxi/useCXI';

import { Container } from '../container';
import * as Styled from './StyledContributionAdd';

export const ContributionAdd = () => {
    const { t, modal, setModal } = useCXI();
    const { match } = modal;

    return (
        <Styled.ContributionAdd as={Container.Slim}>
            <Container.Head image={match.startup.logoUrl} />

            <Container.Body>
                <Styled.Title>{t('modal.ContributionAdd.title')}</Styled.Title>
                <Styled.Descr>{t('modal.ContributionAdd.description')}</Styled.Descr>
            </Container.Body>

            <Container.Feet>
                <Button onClick={() => setModal({ match, modal: 'Contribution' })}>
                    <span className="text">{t('modal.ContributionAdd.create')}</span>
                </Button>
                <Button variant="link" onClick={() => setModal(null)}>
                    <span className="text">{t('modal.close')}</span>
                </Button>
            </Container.Feet>
        </Styled.ContributionAdd>
    );
};
